import { useSingleAddressFieldForUnauthenticated } from '../useSingleAddressFieldForUnauthenticated';

type Result = ModelHookResult<{ enabled: boolean }>;

export function useUnauthenticatedSignForm(): Result {
	const {
		data: { enabled: singleAddressFieldEnabledForUnauthenticated },
	} = useSingleAddressFieldForUnauthenticated();

	return {
		data: {
			enabled: singleAddressFieldEnabledForUnauthenticated,
		},
	};
}
